import { render, staticRenderFns } from "./WidgetMontanariNoAccess.vue?vue&type=template&id=32352468&"
import script from "./WidgetMontanariNoAccess.vue?vue&type=script&lang=js&"
export * from "./WidgetMontanariNoAccess.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMontanariNoAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetMontanariNoAccess.vue"
export default component.exports